import { React } from 'Imports';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthService } from '../../oauth/AuthService';
import { GeotabLogin } from '$Pages/GeotabLogin/GeotabLogin';
import { CircularProgress } from '../../MaterialUIComponents';
import { ConfigService } from '../../state/ConfigFreezerService';
import { StandardProtectedRoutePaths } from '../../router/route-sets/standard-route-config';

const Login = () => {
    const location = useLocation();

    if (ConfigService.isRunningEncompassStandAlone()) {
        return <AuthService />;
    } else if (ConfigService.isRunningEncompassIntegrated()) {
        return <Navigate to={StandardProtectedRoutePaths.VideoEvents} replace />;
    } else if (ConfigService.isIntegrationPlatformGeotab()) {
        return <GeotabLogin redirect={location.pathname} />;
    } else {
        return <CircularProgress />;
    }
};

export { Login };
